(function (w, $) {
    const assetId = '~/Controls/MsForm/Feedback.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {
        $(function() {
            // Setup notifications
            const $sentSummaryContainer = $('#' + ctx.pnlSentId);
            const sentSummaryHtml = $sentSummaryContainer.html();

            if ($sentSummaryContainer.length === 1 && sentSummaryHtml) {
                window.PubSub.publish('notification.success',
                    {
                        timeout: false,
                        text: sentSummaryHtml
                    });
                $sentSummaryContainer.remove();
            }
        });
    }
})(window, jQuery);